import { faArrowUpFromBracket, faSpinner } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ButtonProps, css, styled, useMediaQuery } from '@mui/material';
import { forwardRef, PropsWithChildren } from 'react';
import { device } from 'src/constants/mediaQueries';

interface Props extends ButtonProps {
  loading: boolean;
}

export const UploadButton = forwardRef<HTMLButtonElement, PropsWithChildren<Props>>(
  (props: PropsWithChildren<Props>, ref) => {
    const { loading, disabled, children, ...otherProps } = props;
    const isMobile = useMediaQuery(device.mobileOrTablet);
    return (
      <StyledUploadButton
        ref={ref}
        variant="contained"
        size={isMobile ? /* istanbul ignore next */ 'medium' : 'large'}
        startIcon={
          loading ? (
            <FontAwesomeIcon icon={faSpinner} size="3x" spin />
          ) : (
            <FontAwesomeIcon icon={faArrowUpFromBracket} size="3x" />
          )
        }
        data-testid="upload-sbom-button"
        disabled={loading || disabled}
        type="submit"
        {...otherProps}
      >
        {children}
      </StyledUploadButton>
    );
  }
);

const StyledUploadButton = styled(Button)`
  ${({ theme }) => css`
    font-size: ${theme.typography.body2.fontSize};
    font-weight: ${theme.typography.h1.fontWeight};
  `};

  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: ${({ theme }) => theme.typography.body1.fontSize};
  }

  text-transform: unset;
  background-color: black;
  &:hover {
    background-color: ${({ theme }) => theme.palette.secondary.light};
  }
  .MuiButton-startIcon {
    margin-right: 1rem;
  }
`;
